import React from 'react'
import Input from 'components/common/input/Input'
import CustomModal from 'components/common/modal/CustomModal'
import { teamInitialValues, teamValidationSchema } from 'constants/Teams'
import { ErrorMessage, Formik, Form, FieldArray } from 'formik'
import PropTypes from 'prop-types'

function TeamModal({
  handleCloseModal,
  selectedTeam,
  handleSaveTeam,
  handleUpdateTeam,
}) {
  return (
    <CustomModal
      size='md'
      show
      onHide={handleCloseModal}
      heading={`${selectedTeam ? 'Edit' : 'Create'} Team`}
    >
      <Formik
        initialValues={selectedTeam || teamInitialValues}
        validationSchema={teamValidationSchema}
        enableReinitialize
        onSubmit={(values, { resetForm }) => {
          console.log(selectedTeam)
          console.log(values)
          if (selectedTeam) {
            handleUpdateTeam(values)
          } else handleSaveTeam(values)
          resetForm()
        }}
      >
        {({ handleChange, values, errors, setFieldValue }) => {
          console.log('errors are ', errors)
          return (
            <Form className='form-main'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='field-wrapper'>
                    <Input
                      name='name'
                      handleChange={handleChange}
                      placeholder='Team Name'
                      label='Team Name*'
                      value={values.name}
                    />
                    <ErrorMessage
                      className='error-text'
                      component='p'
                      name='name'
                    />
                  </div>
                </div>

                <div className='col-md-12'>
                  <div className='field-wrapper'>
                    <Input
                      name='objective'
                      handleChange={handleChange}
                      placeholder='Objective'
                      label='Objective*'
                      value={values.objective}
                      // type='textarea'
                    />
                    <ErrorMessage
                      className='error-text'
                      component='p'
                      name='objective'
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='ms-2 col-md-6 field-wrapper'>
                    <Input
                      name='teamLead.name'
                      handleChange={handleChange}
                      placeholder='Team Leader'
                      label='Team Leader*'
                      value={values.teamLead?.name}
                      // type="textarea"
                    />
                    <ErrorMessage
                      className='error-text'
                      component='p'
                      name='teamLead.name'
                    />
                  </div>
                  <div
                    className='ms-4 col-md-4'
                    style={{ padding: '58px 0px 0px 0px' }}
                  >
                    <input
                      type='file'
                      className='btn btn-light'
                      onChange={(e) =>
                        setFieldValue('teamLead.image', e.target.files[0])
                      }
                    />
                    <ErrorMessage
                      className='error-text'
                      component='p'
                      name='teamLead.image'
                    />
                  </div>
                </div>

                <div className='col-md-12'>
                  <h5>Facilitators</h5>
                  <FieldArray
                    name='facilitators'
                    render={(arrayHelpers) => (
                      <div>
                        {values.facilitators?.map((facilitator, index) => (
                          <div key={facilitator} className='field-wrapper mb-3'>
                            <Input
                              name={`facilitators.${index}.name`}
                              placeholder='Facilitator Name'
                              label='Name'
                              handleChange={handleChange}
                              value={facilitator?.name}
                            />
                            <ErrorMessage
                              className='error-text'
                              component='p'
                              name={`facilitators.${index}.name`}
                            />

                            <div className='d-flex justify-content-between'>
                              <input
                                type='file'
                                className='btn btn-light me-4'
                                onChange={(e) =>
                                  setFieldValue(
                                    `facilitators.${index}.image`,
                                    e.target.files[0]
                                  )
                                }
                              />
                              <ErrorMessage
                                className='error-text'
                                component='p'
                                name={`facilitators.${index}.image`}
                              />

                              <button
                                type='button'
                                onClick={() => arrayHelpers.remove(index)}
                                className='btn btn-danger align-self-xl-end'
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        ))}

                        <button
                          type='button'
                          onClick={() =>
                            arrayHelpers.push({ name: '', image: null })
                          }
                          className='primary-btn mt-3'
                        >
                          Add Facilitator
                        </button>
                      </div>
                    )}
                  />
                </div>

                <div className='col-md-12 d-flex justify-content-end gap-4 mt-2'>
                  <button
                    type='button'
                    className='secondary-btn record-btn'
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                  <button type='submit' className='primary-btn record-btn'>
                    Save
                  </button>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </CustomModal>
  )
}

TeamModal.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  selectedTeam: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    _id: PropTypes.string.isRequired,
  }),
  handleSaveTeam: PropTypes.func.isRequired,
  handleUpdateTeam: PropTypes.func.isRequired,
}

TeamModal.defaultProps = {
  selectedTeam: null,
}

export default TeamModal
